import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-hrm-mult/style/index.js